<template>
	<div>
		<div class="moderatorChat-moderatorView">
			<p class="moderatorChat-empty" v-if="actors.length == 0">
				{{
					t("global.no_child_for_parent_yet", {
						child_model_name: t("activerecord.models.user", { count: "other" }),
						parent_model_name: t("activerecord.models.cloned_game", {
							count: "other",
						}),
					})
				}}
			</p>
			<p
				class="moderatorChat-empty"
				v-if='actors.length > 0 && chats.length == 0 && chats_loaded && showingView == "new"'
			>
				{{ t("moderator_chats.empty_moderator") }}
			</p>
			<div v-if="actors.length || chats.length">
				<div class="moderatorChatHeader">
					<!-- @vue-expect-error -->
					<div
						v-if='this.chats.length && showingView == "new"'
						class="button button--secondary"
						v-on:click='(e) => changeView(e, "index")'
					>
						<span class="senaryon-icon senaryon-icon-chat"></span>
						{{ t("chats.inbox") }}
					</div>
					<div
						v-if='showingView == "index"'
						class="button button--secondary"
						v-on:click='(e) => changeView(e, "new")'
					>
						<span class="senaryon-icon senaryon-icon-chat"></span>
						{{ t("chats.compose_message") }}
					</div>
					<div
						class="moderatorChat-errors"
						v-if="error_msg != undefined"
						v-on:click="clearErrors"
					>
						{{ error_msg }}
						<span
							class="senaryon-icon senaryon-icon-close"
							v-on:click="clearErrors"
						></span>
					</div>
				</div>
				<div class="moderatorChatBody">
					<div class="moderatorChatNew" v-if='showingView == "new"'>
						<div class="moderatorChatForm">
							<p v-if="actors.length == 0">{{ t("helpers.loading") }}</p>
							<div class="selectableActors">
								<table>
									<!-- @vue-expect-error -->
									<tr
										:class="selectableActorClasses(actor.id)"
										v-for="actor in actors"
										:key="actor.id"
										v-on:click="toggleRecipient(actor)"
									>
										<td>
											<!-- @vue-expect-error -->
											<input
												v-on:click="stopProp"
												:id="`moderatorChat-recipient-${actor.id}`"
												type="checkbox"
												v-model="selectedRecipients"
												:value="actor.id"
											>
										</td>
										<td :style='{ width: "15px" }'>
											<actor-online-status :actor="actor"></actor-online-status>
										</td>
										<td>
											<strong>
												<!-- @vue-expect-error --> {{ actor.name }}</strong
											>
										</td>
										<td>
											<em>
												<!-- @vue-expect-error -->
												{{ actor.principal_group.name }}</em
											>
										</td>
										<td><!-- @vue-expect-error --> {{ actor.user_name }}</td>
									</tr>
								</table>
							</div>
							<div class="moderatorChatConversation-form">
								<p>
									<!-- @vue-expect-error -->
									<a
										href
										v-on:click="toggleAll"
										style="text-align: center; display: block;"
										>{{
											selectAllNoneText()
										}}</a
									>
								</p>
								<textarea
									id="moderatorChatForm-newMessage"
									v-model="messageContent"
									:placeholder='t("moderator_chats.compose_message")'
								></textarea>
								<button
									class="pull-right"
									:disabled="!canSendMessage"
									v-on:click="sendMessage"
								>
									{{ t("helpers.submit.message.create") }}
									<!-- @vue-expect-error -->
									{{ this.sending ? "…" : "" }}
								</button>
							</div>
						</div>
					</div>
					<div class="moderatorChatIndex" v-if='showingView == "index"'>
						<div class="moderatorChatConversations">
							<!-- @vue-expect-error -->
							<div
								:class="conversationListItemClasses(chat)"
								v-for="chat in chats"
								:key="chat.id"
								v-on:click="openChat(chat)"
								:style="{ background: `transparent url(${chat.actor.avatar_url}) 10px 10px no-repeat` }"
							>
								<div class="actorName">
									<!-- @vue-expect-error -->
									<actor-online-status
										:style='{ marginRight: "5px" }'
										:actor="chat.actor"
									></actor-online-status>
									<strong>
										<!-- @vue-expect-error -->
										{{ chat.actor.user_name }}</strong
									>
									<em
										>(<!-- @vue-expect-error --><!-- @vue-expect-error -->
										<!-- @vue-expect-error --> <!-- @vue-expect-error -->
										{{ chat.actor.name }})</em
									>
								</div>
								<div>
									<small
										>&mdash; <!-- @vue-expect-error --><!-- @vue-expect-error -->
										<!-- @vue-expect-error --> <!-- @vue-expect-error -->
										{{ chat.actor.principal_group.name }}</small
									>
								</div>
								<div :id="`message-${lastMessage(chat).id}`">
									<div class="messageContent">
										{{ lastMessage(chat).content.truncate(80) }}
									</div>
									<time
										class="timeago"
										:datetime="lastMessage(chat).created_at"
										:data-time-ago="lastMessage(chat).created_at"
									></time>
								</div>
							</div>
						</div>
						<moderator-conversation
							:chat="openedChat"
							:sending="sending"
							@replied="reply"
						></moderator-conversation>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
// Other components
import { i18n } from "../utils";
import ActorOnlineStatus from "./actor_online_status.vue";
import ModeratorConversation from "./moderator_conversation.vue";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: { srvUnreadMessagesCount: Number },
	data: function () {
		return {
			chats: [],
			actors: [],
			chats_loaded: false,
			sending: false,
			lastOpened: this.srvLastOpened,
			selectedRecipients: [],
			openedChat: undefined,
			messageContent: "",
			error_msg: undefined,
			showingView: undefined,
		};
	},
	components: {
		"moderator-conversation": ModeratorConversation,
		"actor-online-status": ActorOnlineStatus,
	},
	computed: {
		canSendMessage: function () {
			return (
				this.selectedRecipients.length > 0 &&
				this.messageContent.length > 0 &&
				!this.sending
			);
		},
	},
	updated() {
		window.$(".moderatorChat-moderatorView .timeago").timeago();
	},
	mounted() {
		// @ts-expect-error
		this.showingView = this.chats.length > 0 ? "index" : "new";
		// Called via shown.bs.tab in _communications_modal_content
		pp.vue.bus.$on("moderator_chat_tab-OPEN", (selectRecipientIds) => {
			$.post("/moderator_chats/opened_chat.json", (res) => {});
		});
		this.initalizeChat();
		pp.vue.bus.$on("moderator_chat-CREATE", (chat) => {
			// @ts-expect-error
			this.chats.push(chat);
			this.openedChat = chat;
		});
		pp.vue.bus.$on("moderator_chat_message-CREATE", (msg) => {
			this.handleNewMessage(msg);
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("moderator_chat_tab-OPEN");
		pp.vue.bus.$off("moderator_chat_message-CREATE");
		pp.vue.bus.$off("moderator_chat-CREATE");
	},
	methods: {
		openChat(chat) {
			this.openedChat = chat;
			this.scrollToChatBottom();
		},
		selectAllNoneText() {
			return window.I18n.t(
				this.selectedRecipients.length
					? "moderator_chats.select_none"
					: "moderator_chats.select_all",
			);
		},
		toggleRecipient(actor) {
			let idx = _.findIndex(this.selectedRecipients, (a) => {
				return a == actor.id;
			});
			if (idx == -1) {
				// @ts-expect-error
				this.selectedRecipients.push(actor.id);
			} else {
				this.selectedRecipients.splice(idx, 1);
			}
		},
		toggleAll(e) {
			e.preventDefault();
			// @ts-expect-error
			this.selectedRecipients =
				// @ts-expect-error
				this.selectedRecipients.length > 0 ? [] : this.actors.map((a) => a.id);
		},
		sendMessage(e, obj) {
			let recipient_ids = null;
			let content = null;
			this.sending = true;
			if (obj != undefined) {
				recipient_ids = [obj.actor.id];
				content = obj.messageContent;
			} else {
				recipient_ids = this.selectedRecipients;
				content = this.messageContent;
			}
			if (recipient_ids && recipient_ids.length && content) {
				$.post(
					"/moderator_chat_messages.json",
					{
						recipients: recipient_ids,
						message_content: content,
					},
					(res) => {
						this.handleModeratorNewChat(res);
						if (res.error_msg) {
							this.error_msg = res.error_msg;
						}
						this.clearForms();
						this.sending = false;
					},
				);
				return;
			}
			// Else
			console.error(
				"Error sending moderator_chat_message",
				recipient_ids,
				content,
			);
			this.sending = false;
		},
		reply(obj) {
			this.sendMessage(null, obj);
		},
		lastMessage(chat) {
			return chat.messages.slice(-1)[0];
		},
		handleModeratorNewChat(payload) {
			payload.messages.forEach((message) => {
				this.handleNewMessage(message);
			});
			payload.new_moderator_chats.forEach((chat) => {
				// @ts-expect-error
				this.chats.unshift(chat);
			});
			if (payload.new_moderator_chats.length != 0) {
				this.openedChat =
					payload.new_moderator_chats[payload.new_moderator_chats.length - 1];
			}
			this.changeView(null, "index");
		},
		handleNewMessage(message) {
			let idx = _.findIndex(this.chats, (chat) => {
				// @ts-expect-error
				return message.moderator_chat.id == chat.id;
			});
			if (idx != -1) {
				//Why is this shit doubling is it to do with the moderator_chat being injected with messages in it.
				// @ts-expect-error
				this.chats[idx].messages.push(message);
				// Reorder chats, kinda hacky.
				// @ts-expect-error
				this.chats.unshift(this.chats[idx]);
				this.chats.splice(idx + 1, 1);
				this.scrollToChatBottom();
				this.updateTimeStamps();
				Vue.nextTick(() => {
					window
						.$(`#message-${message.id}`)
						.find(".timeago")
						.timeago("update", message.created_at);
				});
			}
			setTimeout(() => {
				$(".moderatorChatConversation-form textarea").focus();
			}, 50);
		},
		updateTimeStamps() {
			Vue.nextTick(() => {
				window.$(".moderatorChatConversations .timeago").timeago();
			});
		},
		scrollToChatBottom() {
			Vue.nextTick(() => {
				var elem = this.$refs.scrollToBottom;
				if (this.$refs.scrollToBottom) {
					// @ts-expect-error
					elem.scrollTop = this.$refs.scrollToBottom.scrollHeight;
				}
			});
		},
		initalizeChat(selectRecipientIds) {
			this.changeView(null, "new");
			if (this.chats.length == 0) {
				$.get("/moderator_chats.json", (res) => {
					this.chats = res;
					this.chats_loaded = true;
					this.openedChat = this.chats[0];
					if (selectRecipientIds && selectRecipientIds.length > 0) {
						this.openChatOrNewChatWithSelectedRecipient(selectRecipientIds[0]);
					} else if (this.chats.length > 0) {
						// TODO figure out what the unreadCount > 0 || here was doint
						this.changeView(null, "index");
						this.scrollToChatBottom();
					}
				});
			} else if (selectRecipientIds && selectRecipientIds.length > 0) {
				this.openChatOrNewChatWithSelectedRecipient(selectRecipientIds[0]);
			}
			if (!this.actors.length) {
				$.get("/moderator_chats/chattable_actors.json", (res) => {
					this.actors = res.sort(function (a, b) {
						var nameA = a.principal_group.name.toUpperCase(), // ignore upper and lowercase
							nameB = b.principal_group.name.toUpperCase(); // ignore upper and lowercase
						if (nameA < nameB) {
							return -1;
						}
						if (nameA > nameB) {
							return 1;
						}

						// names must be equal
						return 0;
					});
				});
			}
		},
		changeView(e, showView) {
			if (e) {
				e.preventDefault();
			}
			this.showingView = showView;
			if (showView == "index") {
				if (this.chats.length == 1 || this.openedChat === undefined) {
					this.openedChat = this.chats[0];
				}
			}
		},
		openChatOrNewChatWithSelectedRecipient(selectRecipientId) {
			const existingChatIdx = _.findIndex(this.chats, (chat) => {
				// @ts-expect-error
				return chat.actor.id == selectRecipientId;
			});
			if (existingChatIdx == -1) {
				this.changeView(null, "new");
				this.selectedRecipients =
					this.selectedRecipients.concat(selectRecipientId);
			} else {
				this.openChat(this.chats[existingChatIdx]);
				this.changeView(null, "index");
			}
		},
		conversationMessageClasses(message) {
			let classes = "moderatorChatConversation-message";
			if (message.from_moderator) {
				classes += " moderatorChatConversation-message-fromModerator";
			}
			return classes;
		},
		conversationListItemClasses(chat) {
			let classes = "moderatorChatConversations-item";
			// @ts-expect-error
			if (this.openedChat && this.openedChat.id == chat.id) {
				classes += " active";
			}
			return classes;
		},
		selectableActorClasses(actorId) {
			let classes = "selectableActor";
			// @ts-expect-error
			if (this.selectedRecipients.includes(actorId)) {
				classes += " selected";
			}
			return classes;
		},
		clearErrors(e) {
			e.preventDefault();
			e.stopPropagation();
			this.error_msg = undefined;
		},
		clearForms() {
			this.selectedRecipients = [];
			this.messageContent = "";
		},
		stopProp(e) {
			e.stopPropagation();
		},
	},
};
</script>
